import { useState } from 'react';
import { Home, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';

/**
 * HTTP status codes that have a sad/confused cat image on http.cat.
 * We pick one at random so the page feels different on each visit.
 */
const SAD_CAT_CODES = [404, 408, 410, 421, 425, 444, 450, 499, 503, 524];

function pickRandomCatCode(): number {
  return SAD_CAT_CODES[Math.floor(Math.random() * SAD_CAT_CODES.length)];
}

/**
 * 404 page with a random sad cat from http.cat.
 * Shown when the user navigates to a route that does not exist.
 */
export function NotFoundPage() {
  const [cat_code, setCatCode] = useState(() => pickRandomCatCode());

  const onShuffleCat = () => {
    setCatCode(pickRandomCatCode());
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 bg-base-200 p-8">

      {/* 404 heading */}
      <div className="flex flex-col items-center gap-2 text-center">
        <h1 className="text-[8rem] font-black leading-none text-primary">
          404
        </h1>
        <p className="text-2xl font-semibold">¿Te perdiste?</p>
        <p className="text-base-content/60 max-w-sm">
          Esta página no existe o fue movida. No te preocupes, también le pasa a los gatos.
        </p>
      </div>

      {/* Sad cat */}
      <div className="relative">
        <img
          key={cat_code}
          src={`https://http.cat/${cat_code}`}
          alt={`Gato triste — error ${cat_code}`}
          className="h-72 w-auto rounded-2xl object-cover shadow-xl"
          loading="lazy"
        />
        <button
          type="button"
          onClick={onShuffleCat}
          className="absolute -bottom-3 -right-3 btn btn-circle btn-sm btn-neutral shadow"
          title="Otro gato"
        >
          <RefreshCw className="h-3.5 w-3.5" />
        </button>
      </div>

      {/* CTA */}
      <Link to="/" className="btn btn-primary gap-2">
        <Home className="h-4 w-4" />
        Volver al inicio
      </Link>

    </div>
  );
}
